window.ExpertPopup = LayerPopup.extend({
    initialize: function(url) {
        this.name = "ExpertPopup";
        LayerPopup.prototype.initialize.call(this, url);
    },

    setup: function(container) {
        this.container = container;
        this.session = this.container.getSession();
        this.skillManager = this.container.getComponent("SkillsManager");

        var count = this.container.tracking.getItem(ExpertPopup.SAME_RATING_COUNT);
        var lastRating = this.container.tracking.getItem(ExpertPopup.LAST_RATING);

        this.count = (count != -1) ? Number(count) : 0;
        this.lastRating = (lastRating != -1) ? Number(lastRating) : -1;
        //Logger.info("EX------->", this.count, this.lastRating);

        this.questionPopup = undefined;
        //this.listenTo(this.container.screenManager, "onBlockRendered", this.handleBlockRendered);
        this.listenTo(this.session, "onJunctionUpdate", this.handleOnJunctionUpdate);
        this.loadXML(this.url, "");
    },

    handleXMLLoaded: function(e) {
        var $xml = $(e.resource.getXML());
        this.data = {
            title: $xml.find("mainText").find("title").text(),
            content: $xml.find("mainText").find("text").text(),
        };
    },

    // handleBlockRendered: function(e) {
    //     this.hidePopupWindow();
    //     Logger.info("----->", e);
    // },

    handleOnJunctionUpdate: function(e) {
        this.hidePopupWindow();
        var skill = this.skillManager.getSkills({
            pageId: e.pageData.pageID()
        });

        if (skill.length > 0) return;

        if (this.count >= ExpertPopup.FREQUENCY) {
            this.showPopupWindow();
            this.count = 0;
            this.lastRating = -1;
            this.container.tracking.setItem(ExpertPopup.SAME_RATING_COUNT, this.count);
        }

        var block = e.pageData.getBlock(0);
        //Logger.info(e.pageData.pageID(), ":", this.isPageComplete(e.pageData), ":", block.view);

        var self = this;
        this.resizeTimer = setTimeout(function() {
            self.listenToOnce(block.view, "onRatingSelected", self.handleRatingSelected);
        }, 1000);
    },

    handleRatingSelected: function(e) {
        //Logger.info("Ratting selected->", e.rating);
        if ((this.lastRating < 0) || (this.lastRating === e.rating)) {
            this.count++;
        } else {
            this.count = 1;
        }
        //Logger.info("Ratting count->", this.count);
        this.lastRating = e.rating;
        this.container.tracking.setItem(ExpertPopup.LAST_RATING, this.lastRating);
        this.container.tracking.setItem(ExpertPopup.SAME_RATING_COUNT, this.count);
    },

    showPopupWindow: function() {
        var self = this;
        if (this.questionPopup === undefined) {
            this.questionPopup = new AccessibleBootbox({
                title: this.data.title,
                message: this.data.content,
                className: "expert-popup",
                animate: true,
                buttons: {
                    okay: {
                        label: LanguageManager.getString("close"),
                        className: "btn-primary",
                        callback: function() {
                            if (self.questionPopup !== undefined) {
                                self.questionPopup.destroy();
                            }
                            self.questionPopup = undefined;
                        }
                    }
                }
            });
            this.questionPopup.popIn();
        }
    },

    hidePopupWindow: function() {
        if (this.questionPopup) {
            this.questionPopup.popOut();
            this.questionPopup.destroy();
            this.questionPopup = undefined;
        }
    }
}, {
    FREQUENCY: 4,
    LAST_RATING: "last_rating",
    SAME_RATING_COUNT: "same_rating_count"
});
